export const ListQueryKey = 'transRecords';
export const DetailQueryKey = 'transRecord';

export const Urls = {
  selectUrl: '/transRecord/list',
};
